import React from "react";
import { FeildError, FeildWraper, FileUploadProgressBar2, FormArea, FormLabel } from "../../../component/form/form-layout";
import { useApiCall } from "../../../component/custom-hooks/api-call";
import { Plus, Trash2 } from "lucide-react";

const Step4Form = ({ formik, suggestedActions }) => {

    // console.log("suggestedActions", suggestedActions)
    const apiCall = useApiCall();

    // --- File Upload Handler for Screenshots ---
    const handleFileUpload = async (e) => {
        const files = Array.from(e.target.files);
        if (!files.length) return;

        const formData = new FormData();
        files.forEach((file) => formData.append("files[]", file));

        try {
            const res = await apiCall({
                url: "attachments/upload",
                method: "post",
                data: formData,
                headers: { "Content-Type": "multipart/form-data" },
            });

            const uploadedUrls = res.data.map((f) => f.file_url);

            // Append uploaded URLs to formik
            formik.setFieldValue("remarks.screenshotImages", [
                ...formik.values.remarks.screenshotImages,
                ...uploadedUrls,
            ]);
        } catch (err) {
            console.error("Upload failed", err);
        }
    };

    // --- Recording Inputs (manual) ---
    const renderRecordingInputs = () => {
        const fieldValues = formik.values.remarks.recordingLinks;

        return (

            <FeildWraper width="100%">
                {/* Label row with Add button */}
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "8px" }}>
                    <FormLabel>Recording Links</FormLabel>
                    <div
                        onClick={() => formik.setFieldValue("remarks.recordingLinks", [...fieldValues, ""])}
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "4px",
                            cursor: "pointer",
                            color: "#000",
                            fontWeight: "500",
                            fontSize: "14px",
                        }}
                    >
                        <Plus size={16} />
                        <span>Add</span>
                    </div>
                </div>

                {/* Inputs */}
                {fieldValues.map((val, idx) => (
                    <div key={idx} style={{ position: "relative", marginBottom: "12px" }}>
                        <input
                            type="text"
                            placeholder={`Recording ${idx + 1}`}
                            value={val}
                            onChange={(e) => {
                                const arr = [...fieldValues];
                                arr[idx] = e.target.value;
                                formik.setFieldValue("remarks.recordingLinks", arr);
                            }}
                            style={{
                                width: "100%",
                                padding: "8px 36px 8px 12px", // space for delete icon
                                borderRadius: "6px",
                                border: "1px solid #ccc",
                                outline: "none",
                            }}
                        />

                        {/* Delete icon inside input */}
                        {idx !== 0 && fieldValues.length > 1 && (
                            <Trash2
                                size={18}
                                color="#ff4d4f"
                                onClick={() => {
                                    const arr = [...fieldValues];
                                    arr.splice(idx, 1);
                                    formik.setFieldValue("remarks.recordingLinks", arr);
                                }}
                                style={{
                                    position: "absolute",
                                    right: "12px",
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    cursor: "pointer",
                                }}
                            />
                        )}
                    </div>
                ))}
            </FeildWraper>
        );
    };

    return (
        <div className="space-y-6 w-full p-0">
            <FormArea>
                {/* Summary */}
                <FeildWraper width="100%">
                    <FormLabel>Summary of Review</FormLabel>
                    <textarea
                        placeholder="Summary..."
                        value={formik.values.remarks.summary}
                        onChange={(e) => formik.setFieldValue("remarks.summary", e.target.value)}
                        style={{ width: "100%", height: "80px" }}
                    />

                    {formik.errors?.remarks?.summary && (
                        <FeildError>{formik.errors.remarks.summary}</FeildError>
                    )}
                </FeildWraper>

                <FeildWraper width="100%">
                    <FormLabel>Suggested Action</FormLabel>
                    <select
                        value={formik.values.remarks.suggestedAction}
                        onChange={(e) => formik.setFieldValue("remarks.suggestedAction", e.target.value)}
                    >
                        <option value="">Select action</option> {/* <-- placeholder */}
                        {Object.entries(suggestedActions).map(([key, label]) => (
                            <option key={key} value={key}>
                                {label}
                            </option>
                        ))}
                    </select>

                    {formik.errors?.remarks?.suggestedAction && (
                        <FeildError>{formik.errors.remarks.suggestedAction}</FeildError>
                    )}
                </FeildWraper>

                {/* Recordings (manual) */}
                {renderRecordingInputs()}

                {/* Timestamp Notes */}
                <FeildWraper width="100%">
                    <FormLabel>Timestamp Notes</FormLabel>
                    {formik.values.remarks.timestampNotes.map((note, idx) => (
                        <input
                            key={idx}
                            type="text"
                            placeholder="Timestamp"
                            value={note}
                            onChange={(e) => {
                                const arr = [...formik.values.remarks.timestampNotes];
                                arr[idx] = e.target.value;
                                formik.setFieldValue("remarks.timestampNotes", arr);
                            }}
                            style={{ width: "100%", marginBottom: "6px" }}
                        />
                    ))}
                </FeildWraper>

                {/* Screenshots (multi-select upload only) */}
                {/* <FeildWraper width="100%">
                    <FormLabel>Screenshot Upload</FormLabel>
                    <input
                        type="file"
                        multiple
                        onChange={handleFileUpload}
                        style={{ marginTop: "8px" }}
                    />
                </FeildWraper> */}

                <FeildWraper width="100%">
                    <FormLabel>Screenshot Upload</FormLabel>
                    <FileUploadProgressBar2
                        mode="multi" // multiple files
                        acceptType="image" // only images
                        onChange={(uploadedUrls) => {
                            // Save uploaded URLs to formik
                            formik.setFieldValue("remarks.screenshotImages", uploadedUrls);
                        }}
                    />
                </FeildWraper>
            </FormArea>
        </div>
    );
};

export default Step4Form;
